import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { isStatusTrue } from "../utils/patientUtils";
import { summaryInnerCard } from "./patientSummaryUi";
import type { SummaryTheme } from "./patientSummaryUi";

interface MedicalConditionCardProps {
  label: string;
  condition: { status?: string | boolean; note?: string };
  theme?: SummaryTheme;
  hideWhenInactive?: boolean;
}

const MedicalConditionCard: React.FC<MedicalConditionCardProps> = ({
  label,
  condition,
  theme = "light",
  hideWhenInactive = false,
}) => {
  const isActive = isStatusTrue(condition?.status);
  const noteText = condition?.note != null ? String(condition.note).trim() : "";

  if (hideWhenInactive && !isActive && !noteText) {
    return null;
  }

  return (
    <div className={summaryInnerCard(theme, isActive)}>
      <div className="flex items-center justify-between gap-2">
        <p className={`text-sm font-semibold ${theme === "dark" ? "text-slate-200" : "text-slate-800"}`}>
          {label}
        </p>
        {isActive ? (
          <CheckCircleIcon className={theme === "dark" ? "text-red-400" : "text-red-500"} sx={{ fontSize: 17 }} />
        ) : (
          <CancelIcon className={theme === "dark" ? "text-slate-600" : "text-slate-300"} sx={{ fontSize: 17 }} />
        )}
      </div>
      {isActive && noteText && (
        <p className={`mt-1.5 text-xs leading-relaxed ${theme === "dark" ? "text-red-300/90" : "text-red-700"}`}>
          {noteText}
        </p>
      )}
    </div>
  );
};

export default MedicalConditionCard;
